import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardBody, Col, Form, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import moment from "moment";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { clearGetAllDataRsreserve, getAllDataRsreserve } from "../../redux/handlers/reservation/getAllDataRsreserve.handler";
import { allSetUser, clearallSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { getShop } from "../../redux/handlers/manage/getShop.handler";
import { formatReservationDuration, formatReservationTimestamp, isReservationDurationAtLeastOneDay } from "utils/reservationDuration";
var SALE_STATUSES = [
    {
        value: 0,
        label: "ทั้งหมด"
    },
    {
        value: 1,
        label: "รอติดต่อ"
    },
    {
        value: 2,
        label: "ยืนยันแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    }
];
var RESERVATION_STATUSES = [
    {
        value: 0,
        label: "ทั้งหมด"
    },
    {
        value: 1,
        label: "รอยืนยัน"
    },
    {
        value: 4,
        label: "กำลังจัดสินค้า"
    },
    {
        value: 7,
        label: "ตรวจสอบสินค้า"
    },
    {
        value: 5,
        label: "รอส่งสินค้า"
    },
    {
        value: 2,
        label: "ส่งสินค้าแล้ว"
    },
    {
        value: 6,
        label: "ชำระเงินแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    }
];
var SHOP_TYPES = [
    {
        value: "",
        label: "ทั้งหมด"
    },
    {
        value: 1,
        label: "RT"
    },
    {
        value: 2,
        label: "WT"
    },
    {
        value: 3,
        label: "MT"
    }
];
var statusCountText = function(counts, group, statusId) {
    var _groupCounts_by_status;
    var groupCounts = (counts === null || counts === void 0 ? void 0 : counts[group]) || {};
    var value = Number(statusId) === 0 ? groupCounts.all : (_groupCounts_by_status = groupCounts.by_status) === null || _groupCounts_by_status === void 0 ? void 0 : _groupCounts_by_status[String(statusId)];
    return Number(value || 0).toLocaleString("en-US");
};
var shopTypeText = function(row) {
    var _row_shShop, _SHOP_TYPES_find;
    var typeId = Number(row === null || row === void 0 ? void 0 : (_row_shShop = row.shShop) === null || _row_shShop === void 0 ? void 0 : _row_shShop.sh_shop_typeshop);
    return ((_SHOP_TYPES_find = SHOP_TYPES.find(function(item) {
        return item.value !== "" && Number(item.value) === typeId;
    })) === null || _SHOP_TYPES_find === void 0 ? void 0 : _SHOP_TYPES_find.label) || "-";
};
var shopNameText = function(row) {
    var shopName = (row === null || row === void 0 ? void 0 : row.rs_reserve_shopname_full) || (row === null || row === void 0 ? void 0 : row.rs_reserve_shopname) || "";
    var branchName = (row === null || row === void 0 ? void 0 : row.rs_reserve_branchname) || "";
    return [
        shopName,
        branchName ? "(".concat(branchName, ")") : ""
    ].filter(Boolean).join(" ") || "-";
};
var dateColumn = function(name, field) {
    return {
        name: name,
        selector: function(row) {
            return row[field];
        },
        cell: function(row) {
            return formatReservationTimestamp(row[field]);
        },
        sortField: field,
        sortable: true,
        center: "true",
        width: "175px"
    };
};
var durationColumn = function(startField, endField) {
    var fallbackStartField = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return {
        name: "ระยะห่าง",
        cell: function(row) {
            var startValue = row[startField] || (fallbackStartField ? row[fallbackStartField] : null);
            var endValue = row[endField];
            var isOverdue = isReservationDurationAtLeastOneDay(startValue, endValue);
            return /*#__PURE__*/ _jsx("span", {
                className: isOverdue ? "text-danger fw-semibold" : "",
                children: formatReservationDuration(startValue, endValue)
            });
        },
        center: "true",
        width: "155px"
    };
};
export function ReportReservationDuration() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var modalContextRef = useRef({
        modalObj: modalObj,
        setModalObj: setModalObj
    });
    var reservationReducer = useAppSelector(function(state) {
        return state.getAllDataRsreserveReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var getShopReducer = useAppSelector(function(state) {
        return state.getShopReducer;
    });
    var _useState = _sliced_to_array(useState([]), 2), rows = _useState[0], setRows = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), shops = _useState1[0], setShops = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), users = _useState2[0], setUsers = _useState2[1];
    var _useState3 = _sliced_to_array(useState(1), 2), pageId = _useState3[0], setPageId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(10), 2), pageSize = _useState4[0], setPageSize = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), totalPage = _useState5[0], setTotalPage = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), totalAmount = _useState6[0], setTotalAmount = _useState6[1];
    var _useState7 = _sliced_to_array(useState({}), 2), sortModel = _useState7[0], setSortModel = _useState7[1];
    var _useState8 = _sliced_to_array(useState({}), 2), statusCounts = _useState8[0], setStatusCounts = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), saleStatus = _useState9[0], setSaleStatus = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), reservationStatus = _useState10[0], setReservationStatus = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), filterText = _useState11[0], setFilterText = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), shopId = _useState12[0], setShopId = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), saleId = _useState13[0], setSaleId = _useState13[1];
    var _useState14 = _sliced_to_array(useState(""), 2), adminId = _useState14[0], setAdminId = _useState14[1];
    var _useState15 = _sliced_to_array(useState(""), 2), shopTypeId = _useState15[0], setShopTypeId = _useState15[1];
    var _useState16 = _sliced_to_array(useState(null), 2), startDate = _useState16[0], setStartDate = _useState16[1];
    var _useState17 = _sliced_to_array(useState(null), 2), endDate = _useState17[0], setEndDate = _useState17[1];
    var _useState18 = _sliced_to_array(useState("custom"), 2), dateRange = _useState18[0], setDateRange = _useState18[1];
    var loading = reservationReducer.isFetching;
    useEffect(function() {
        modalContextRef.current = {
            modalObj: modalObj,
            setModalObj: setModalObj
        };
    }, [
        modalObj,
        setModalObj
    ]);
    useEffect(function() {
        dispatch(allSetUser(modalContextRef.current));
        dispatch(getShop({}, modalContextRef.current));
        return function() {
            dispatch(clearGetAllDataRsreserve());
            dispatch(clearallSetUser());
        };
    }, [
        dispatch
    ]);
    useEffect(function() {
        if (getShopReducer.data && !getShopReducer.isError) {
            var data = getShopReducer.data.data;
            setShops(Array.isArray(data) ? data : []);
        }
    }, [
        getShopReducer
    ]);
    useEffect(function() {
        if (allSetUserReducer.data && !allSetUserReducer.isError) {
            var data = allSetUserReducer.data.data;
            setUsers(Array.isArray(data) ? data : []);
        }
    }, [
        allSetUserReducer
    ]);
    useEffect(function() {
        if (reservationReducer.data && !reservationReducer.isError) {
            var result = reservationReducer.data.data;
            var data = Array.isArray(result) ? result : (result === null || result === void 0 ? void 0 : result.data) || [];
            var pagination = Array.isArray(result) ? {} : (result === null || result === void 0 ? void 0 : result.pagination) || {};
            setRows(data);
            setTotalPage(pagination.totalPage || 0);
            setTotalAmount(pagination.total || data.length);
            setStatusCounts(Array.isArray(result) ? {} : (result === null || result === void 0 ? void 0 : result.status_counts) || {});
        }
        if (reservationReducer.isError) {
            setRows([]);
            setTotalPage(0);
            setTotalAmount(0);
            setStatusCounts({});
        }
    }, [
        reservationReducer
    ]);
    useEffect(function() {
        var timer = setTimeout(function() {
            dispatch(getAllDataRsreserve(_object_spread({
                status: reservationStatus || "",
                salestatus: saleStatus || "",
                pageId: pageId,
                pageSize: pageSize,
                searchtext: filterText
            }, shopId && {
                shopid: Number(shopId)
            }, saleId && {
                saleid: Number(saleId)
            }, adminId && {
                adminid: Number(adminId)
            }, shopTypeId && {
                typeshop: Number(shopTypeId)
            }, startDate && {
                startdate: moment(startDate).format("YYYY-MM-DD")
            }, endDate && {
                enddate: moment(endDate).format("YYYY-MM-DD")
            }, sortModel.sortField && {
                sortField: sortModel.sortField,
                sortValue: sortModel.sortValue
            }), modalContextRef.current));
        }, filterText ? 350 : 0);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        adminId,
        dispatch,
        endDate,
        filterText,
        pageId,
        pageSize,
        reservationStatus,
        saleId,
        saleStatus,
        shopId,
        shopTypeId,
        sortModel,
        startDate
    ]);
    var shopOptions = useMemo(function() {
        var seen = new Set();
        return shops.reduce(function(options, shop) {
            var _shop_shShop;
            var value = (shop === null || shop === void 0 ? void 0 : shop.sh_shop_id) || (shop === null || shop === void 0 ? void 0 : shop.sh_branch_shid);
            if (!value || seen.has(value)) return options;
            seen.add(value);
            var shopName = (shop === null || shop === void 0 ? void 0 : shop.sh_shop_name) || (shop === null || shop === void 0 ? void 0 : (_shop_shShop = shop.shShop) === null || _shop_shShop === void 0 ? void 0 : _shop_shShop.sh_shop_name);
            var branchName = shop === null || shop === void 0 ? void 0 : shop.sh_branch_name;
            options.push({
                value: value,
                label: branchName ? "".concat(shopName || "-", " (").concat(branchName, ")") : shopName || "ร้านค้า ".concat(value)
            });
            return options;
        }, []);
    }, [
        shops
    ]);
    var saleOptions = useMemo(function() {
        return users.filter(function(user) {
            return Number(user.sys_user_role_id) === 3;
        }).map(function(user) {
            return {
                value: user.sys_user_id,
                label: "".concat(user.sys_user_fullname || "-", " (").concat(user.sys_user_nname || "-", ")")
            };
        });
    }, [
        users
    ]);
    var adminOptions = useMemo(function() {
        return users.filter(function(user) {
            return Number(user.sys_user_role_id) === 1;
        }).map(function(user) {
            return {
                value: user.sys_user_id,
                label: "".concat(user.sys_user_fullname || "-", " (").concat(user.sys_user_nname || "-", ")")
            };
        });
    }, [
        users
    ]);
    var columns = useMemo(function() {
        return [
            {
                name: "รหัสใบจอง",
                selector: function(row) {
                    return row.rs_reserve_code;
                },
                cell: function(row) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center justify-content-center gap-1",
                        style: {
                            color: "#565DFF",
                            fontWeight: 500,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "/report/reservation/view/".concat(row.rs_reserve_id),
                            children: row.rs_reserve_code || "ไม่มีรหัส"
                        })
                    });
                },
                sortField: "rs_reserve_code",
                sortable: true,
                center: "true",
                width: "175px"
            },
            {
                name: "ชื่อร้าน",
                selector: function(row) {
                    return row.rs_reserve_shopname;
                },
                cell: function(row) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "text-wrap",
                        children: shopNameText(row)
                    });
                },
                width: "260px"
            },
            {
                name: "ประเภทร้านค้า",
                selector: shopTypeText,
                center: "true",
                width: "145px"
            },
            dateColumn("วันที่จอง", "rs_reserve_credate"),
            durationColumn("rs_reserve_credate", "rs_reserve_saledate"),
            dateColumn("วันที่เซลล์ยืนยัน", "rs_reserve_saledate"),
            durationColumn("rs_reserve_saledate", "rs_reserve_organizedate"),
            dateColumn("กำลังจัดสินค้า", "rs_reserve_organizedate"),
            durationColumn("rs_reserve_organizedate", "rs_reserve_pdcheckedate"),
            dateColumn("ตรวจสอบสินค้า", "rs_reserve_pdcheckedate"),
            durationColumn("rs_reserve_pdcheckedate", "rs_reserve_waitdate", "rs_reserve_organizedate"),
            dateColumn("รอส่งสินค้า", "rs_reserve_waitdate"),
            durationColumn("rs_reserve_waitdate", "rs_reserve_approvedate"),
            dateColumn("ส่งสินค้าแล้ว", "rs_reserve_approvedate")
        ];
    }, []);
    var selectProps = {
        menuPortalTarget: document.body,
        menuPosition: "fixed",
        styles: {
            menuPortal: function(base) {
                return _object_spread_props(_object_spread({}, base), {
                    zIndex: 9999
                });
            },
            menu: function(base) {
                return _object_spread_props(_object_spread({}, base), {
                    zIndex: 9999
                });
            }
        },
        isClearable: true
    };
    var resetPage = function(setter) {
        return function(value) {
            setter(value);
            setPageId(1);
        };
    };
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setStartDate(range.startDate);
            setEndDate(range.endDate);
        }
        setPageId(1);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "tc-7",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item active",
                                    children: "รายงานระยะเวลาการดำเนินงานใบจอง"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานระยะเวลาการดำเนินงานใบจอง"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsxs(Col, {
                        lg: 6,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mb-1 fw-semibold",
                                children: "สถานะเซลล์"
                            }),
                            /*#__PURE__*/ _jsx(Nav, {
                                variant: "pills",
                                activeKey: String(saleStatus),
                                onSelect: function(key) {
                                    setSaleStatus(Number(key || 0));
                                    setPageId(1);
                                },
                                className: "mb-1",
                                children: SALE_STATUSES.map(function(status) {
                                    return /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: String(status.value),
                                            children: [
                                                status.label,
                                                " (",
                                                statusCountText(statusCounts, "sale_status", status.value),
                                                ")"
                                            ]
                                        })
                                    }, status.value);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Col, {
                        lg: 6,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mb-1 fw-semibold",
                                children: "สถานะ"
                            }),
                            /*#__PURE__*/ _jsx(Nav, {
                                variant: "pills",
                                activeKey: String(reservationStatus),
                                onSelect: function(key) {
                                    setReservationStatus(Number(key || 0));
                                    setPageId(1);
                                },
                                className: "mb-1",
                                children: RESERVATION_STATUSES.map(function(status) {
                                    return /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: String(status.value),
                                            children: [
                                                status.label,
                                                " (",
                                                statusCountText(statusCounts, "reserve_status", status.value),
                                                ")"
                                            ]
                                        })
                                    }, status.value);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsxs(CardBody, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-end",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 2,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                            value: dateRange,
                                            onChange: handleDateRangeChange
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 5,
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "row align-items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-4 col-md-12 mb-2",
                                                    children: "ค้นหาตามช่วงวันที่จอง"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3 col-md-5",
                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                        selected: startDate,
                                                        onChange: function(date) {
                                                            setDateRange("custom");
                                                            resetPage(setStartDate)(date);
                                                        },
                                                        dateFormat: "dd-MM-yyyy",
                                                        className: "form-control px-2 mb-2",
                                                        placeholderText: "วันที่เริ่มต้น",
                                                        maxDate: endDate,
                                                        isClearable: true
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-1 col-md-2 text-center mb-2",
                                                    children: "ถึง"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-4 col-md-5",
                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                        selected: endDate,
                                                        onChange: function(date) {
                                                            setDateRange("custom");
                                                            resetPage(setEndDate)(date);
                                                        },
                                                        dateFormat: "dd-MM-yyyy",
                                                        className: "form-control px-2 mb-2",
                                                        placeholderText: "วันที่สิ้นสุด",
                                                        minDate: startDate,
                                                        isClearable: true
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 5,
                                        className: "mb-2",
                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "text",
                                            placeholder: "ค้นหาเลขที่ใบจอง, ชื่อร้าน, สาขา, ชื่อเซลล์, ชื่อแอดมิน",
                                            value: filterText,
                                            onChange: function(event) {
                                                setFilterText(event.target.value);
                                                setPageId(1);
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาร้านค้า",
                                                    options: shopOptions,
                                                    value: shopOptions.find(function(item) {
                                                        return item.value === shopId;
                                                    }) || null,
                                                    onChange: function(option) {
                                                        return resetPage(setShopId)((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    }
                                                }, selectProps))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาเซลล์ที่ดูแล"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                    options: saleOptions,
                                                    value: saleOptions.find(function(item) {
                                                        return item.value === saleId;
                                                    }) || null,
                                                    onChange: function(option) {
                                                        return resetPage(setSaleId)((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    }
                                                }, selectProps))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาแอดมิน"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาแอดมิน",
                                                    options: adminOptions,
                                                    value: adminOptions.find(function(item) {
                                                        return item.value === adminId;
                                                    }) || null,
                                                    onChange: function(option) {
                                                        return resetPage(setAdminId)((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    }
                                                }, selectProps))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาประเภทร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาประเภทร้านค้า",
                                                    options: SHOP_TYPES,
                                                    value: SHOP_TYPES.find(function(item) {
                                                        return item.value === shopTypeId;
                                                    }) || null,
                                                    onChange: function(option) {
                                                        return resetPage(setShopTypeId)((option === null || option === void 0 ? void 0 : option.value) || "");
                                                    }
                                                }, selectProps))
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: rows,
                            columns: columns,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: setPageId,
                            onChangePageSize: function(newSize) {
                                setPageSize(newSize);
                                setPageId(1);
                            },
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            handleSort: function(column, direction) {
                                if (!(column === null || column === void 0 ? void 0 : column.sortField)) return;
                                setSortModel({
                                    sortField: column.sortField,
                                    sortValue: direction
                                });
                                setPageId(1);
                            },
                            loading: loading
                        })
                    })
                ]
            })
        ]
    });
}
